// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"error_errorContainer__1XPaV","content":"error_content__236yO"};